module.exports = __webpack_public_path__ + "img/icn_bits_white.4e118e8f.svg";